import React, { useState, useEffect } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import ApexCharts from 'apexcharts';
import config from 'react-global-configuration';
import AWS from 'aws-sdk';
import axios from 'axios';
import toastr from "toastr";


function Details({ propertie, onShowReport, onShowEdit }) {

    //const [data, setData] = useState(null);

    useEffect(() => {
        var options = {
            series: [propertie.score],
            chart: {
                type: 'radialBar',
                offsetY: -20,
                sparkline: {
                    enabled: true
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -90,
                    endAngle: 90,
                    track: {
                        background: "#e7e7e7",
                        strokeWidth: '97%',
                        margin: 5, // margin pixels
                        dropShadow: {
                            enabled: true,
                            top: 2,
                            left: 0,
                            color: '#999',
                            opacity: 1,
                            blur: 2
                        }
                    },
                    dataLabels: {
                        name: {
                            show: false
                        },
                        value: {
                            offsetY: -2,
                            fontSize: '22px'
                        }
                    }
                }
            },
            grid: {
                padding: {
                    top: -10
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    shadeIntensity: 0.4,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 50, 53, 91]
                },
            },
            labels: ['Score'],
        };

        if (propertie.score) {
            var chart = new ApexCharts(document.querySelector("#chart"), options);
            chart.render();
        }

    }, []);

    const handleClickFile = async (fileName, local) => {
        // const s3 = new AWS.S3({
        //     accessKeyId: config.get('s3.accessKeyId'),
        //     secretAccessKey: config.get('s3.secretAccessKey'),
        //     region: config.get('s3.region')
        // });

        if (local !== 'kml') {
            if (fileName.toString().toLocaleLowerCase().split('.pdf').length <= 1) {
                fileName = fileName + '.pdf';
            }
        }
        const file = [];

        const params = {
            Bucket: local === 'kml' ? config.get('s3.bucketKML') : config.get('s3.bucketFiles'),
            Key: fileName,
        };

        const urlDownload = config.get('urlbase') + '/imoveis/download-file?contract_id='+ JSON.parse(localStorage.getItem('userInfos')).data.contract_id + '&customercnpj='+ JSON.parse(localStorage.getItem('userInfos')).data.customercnpj + '&imovel_id=' + propertie.imovel_id + '&filename=' + params.Key;
        const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token, 'Content-Type': 'application/json' };
        
        try {
            const fileUrl = (await axios.get(urlDownload, { headers })).data.Item;
            //const url = await s3.getSignedUrlPromise('getObject', params);
            file.push({ url: fileUrl.Url });
            window.open(file[0].url);
            console.log(file);
        } catch (error) {
            toastr.error('Erro ao obter o arquivo: ' + error.response.data.Erro);
        }
    }

    return (
        <Container fluid className='details-content'>
            <Row>
                <Col md={6}>
                    <h5>Dados da Propriedade <a className='bt-edit float--r' href='javascript:void(0);' onClick={() => { onShowEdit(propertie) }}><i className="bi bi-pencil-square"></i> Editar Dados</a></h5>
                    <span className='title-name'>
                        {propertie.name}
                        <small>{propertie?.coords}</small>
                    </span>

                    <div className='info-br'>
                        <Col md={6}>
                            <label><b>CNPJ:</b></label>
                            <span>{propertie?.cnpj}</span>
                        </Col>
                        <Col md={6}>
                            {propertie.elaw &&
                            <>
                                <label><b>Sistema Jurídico:</b></label>
                                <span>{propertie?.elaw}</span>
                            </>
                            }
                        </Col>
                    </div>
                    <div className='d-flex p-3 mt-3'>
                        <Col md={6}>
                            <b>Score</b>
                            {propertie.score ? <div id='chart' style={{ width: '176px', margin: '0 auto' }}></div> : <p><br />Sem dados de Score</p>}
                           
                        </Col>
                        <Col md={6}>
                            <Button variant="info" type="button" className='margin--auto display--block' onClick={() => handleClickFile(propertie?.kml, 'kml')}>
                                <i className="bi bi-cloud-download-fill"></i>  Download do Arquivo KML
                            </Button>
                            <Button variant="info" type="button" className='margin--auto display--block mt-3' onClick={onShowReport}>
                                <i className="bi bi-cloud-download-fill"></i>  Download do Relatório
                            </Button>
                        </Col>

                    </div>
                    <Row className='mt-3 mb-3'>
                        <Col md={6}>
                            <b>O Imóvel é prórprio?</b> {propertie?.ownership.isOwProperty ? 'Sim' : 'Não'}
                        </Col>
                        <Col md={6}>{propertie?.ownership.isOwProperty ? <b>Arrendo o imóvel para terceiro? </b> : <b>Arrendo o imóvel de terceiro? </b>}
                            {propertie?.ownership.isOwProperty ?
                                (propertie?.ownership.rentToThirdParty ? 'Sim' : 'Não')
                                : (propertie?.ownership.rentFromThirdParty ? 'Sim' : 'Não')
                            }
                        </Col>
                    </Row>
                    {propertie.ownership && propertie.ownership.files && propertie.ownership.files.length > 0 ? propertie.ownership.files.map((item, index) =>
                    (<div key={index}>
                        <Button variant="light" type="button" size="sm" onClick={() => handleClickFile(item.name, 'propriedade')}>
                            <i className="bi bi-cloud-download-fill"></i>  {item.title}
                        </Button>
                        <p>
                            {item.comments}
                        </p>
                    </div>)
                    ) : ''}

                </Col>
                <Col md={6}>
                    <h5>Outras Informações da Propriedade</h5>

                    <section className='scrollbar list-info'>
                        {propertie.licensingWaiver && propertie.licensingWaiver.length > 0 ? <h6>Dispensa de Licenciamento</h6> : ''}
                        {propertie.licensingWaiver && propertie.licensingWaiver.length > 0 ? propertie.licensingWaiver.map((item, index) =>
                        (<div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                            <p><b>Orgão:</b> {item.organ}</p>
                            <p className='mt-3'><b>Atividade: </b>{item.activity}</p>
                            <p className='mt-3'><b>Data de Início: </b>{item.startDate}</p>
                            {item.endDate && item.endDate !== '' ? <p className='mt-3'><b>Data de Validade: </b>{item.endDate}</p> : ''}
                            {item.file  && item.file.name ?
                                <Button variant="light" type="button" size="sm" onClick={() => handleClickFile(item.file.name, 'propriedade')}>
                                    <i className="bi bi-cloud-download-fill"></i>  {item.file.title || item.file.name}
                                </Button> : ''}
                            <p className='mt-3'>
                                {item.file && item.file.comments && item.file.comments !== '' ? <span><b>Observações:</b> {item.file.comments}</span> : ''}
                            </p>
                        </div>)
                        ) : ''}

                        {propertie.environmentalLicense && propertie.environmentalLicense.length > 0 ? <h6 className='mt-3'>Licença Ambiental</h6> : ''}
                        {propertie.environmentalLicense && propertie.environmentalLicense.length > 0 ? propertie.environmentalLicense.map((item, index) =>
                        (<div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                            <p><b>Orgão:</b> {item.organ}</p>
                            <p className='mt-3'><b>Atividade: </b>{item.activity}</p>
                            <p className='mt-3'><b>Data de Início: </b>{item.startDate}</p>
                            {item.endDate && item.endDate !== '' ? <p className='mt-3'><b>Data de Validade: </b>{item.endDate}</p> : ''}
                            {item.file  && item.file.name ?
                                <Button variant="light" type="button" size="sm" onClick={() => handleClickFile(item.file.name, 'propriedade')}>
                                    <i className="bi bi-cloud-download-fill"></i>  {item.file.title || item.file.name}
                                </Button> : ''}
                            <p className='mt-3'>
                                {item.file && item.file.comments && item.file.comments !== '' ? <span><b>Observações:</b> {item.file.comments}</span> : ''}
                            </p>
                        </div>)
                        ) : ''}

                        {propertie.noticeInfraction && propertie.noticeInfraction.length > 0 ? <h6 className='mt-3'>Auto de Infração</h6> : ''}
                        {propertie.noticeInfraction && propertie.noticeInfraction.length > 0 ? propertie.noticeInfraction.map((item, index) =>
                        (<div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                            <p><b>Orgão Autuante:</b> {item.organ} <b className='ms-3'>Número / Ano:</b> {item.numberYear}</p>
                            <p className='mt-3'><b>Valor da Multa:</b> {item.fineAmount}</p>
                            {propertie?.suspension ?
                                <p className='mt-3'><b>Suspensão:</b> (data?.suspension ? 'Sim' : 'Não')</p>
                                : ''
                            }
                            {propertie?.embargo ?
                                <p className='mt-3'><b>Embargo:</b> (data?.embargo ? 'Sim' : 'Não')</p>
                                : ''
                            }
                            {item.file  && item.file.name ?
                                <Button variant="light" type="button" size="sm" onClick={() => handleClickFile(item.file.name, 'propriedade')}>
                                    <i className="bi bi-cloud-download-fill"></i>  {item.file.title || item.file.name}
                                </Button> : ''}
                            <p className='mt-3'>
                                {item.file && item.file.comments && item.file.comments !== '' ? <span><b>Observações:</b> {item.file.comments}</span> : ''}
                            </p>
                        </div>)
                        ) : ''}

                        {propertie.tacAgency && propertie.tacAgency.length > 0 ? <h6 className='mt-3'>TAC Orgão Ambiental</h6> : ''}
                        {propertie.tacAgency && propertie.tacAgency.length > 0 ? propertie.tacAgency.map((item, index) =>
                        (<div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                            <p><b>Orgão:</b> {item.organ} <b className='ms-3'>Data de Assinatura:</b> {item.signDate}</p>
                            <p className='mt-3'><b>Número do TAC: {item.number}</b></p>
                            {item.file  && item.file.name ?
                                <Button variant="light" type="button" size="sm" onClick={() => handleClickFile(item.file.name, 'propriedade')}>
                                    <i className="bi bi-cloud-download-fill"></i>  {item.file.title || item.file.name}
                                </Button> : ''}
                            <p className='mt-3'>
                                {item.file && item.file.comments && item.file.comments !== '' ? <span><b>Observações:</b> {item.file.comments}</span> : ''}
                            </p>
                        </div>)
                        ) : ''}

                        {propertie.tacMp && propertie.tacMp.length > 0 ? <h6 className='mt-3'>TAC Ministério Público</h6> : ''}
                        {propertie.tacMp && propertie.tacMp.length > 0 ? propertie.tacMp.map((item, index) =>
                        (<div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                            <p><b>Orgão:</b> {item.organ} <b className='ms-3'>Data de Assinatura:</b> {item.signDate}</p>
                            <p className='mt-3'><b>Número do TAC: {item.number}</b></p>
                            {item.file  && item.file.name ?
                                <Button variant="light" type="button" size="sm" onClick={() => handleClickFile(item.file.name, 'propriedade')}>
                                    <i className="bi bi-cloud-download-fill"></i>  {item.file.title || item.file.name}
                                </Button> : ''}
                            <p className='mt-3'>
                                {item.file && item.file.comments && item.file.comments !== '' ? <span><b>Observações:</b> {item.file.comments}</span> : ''}
                            </p>
                        </div>)
                        ) : ''}

                        {propertie.otherAdministrativeProcesses && propertie.otherAdministrativeProcesses.length > 0 ? <h6 className='mt-3' style={{ width: '40%' }}>Outros Processos Administrativos</h6> : ''}
                        {propertie.otherAdministrativeProcesses && propertie.otherAdministrativeProcesses.length > 0 ? propertie.otherAdministrativeProcesses.map((item, index) =>
                        (<div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                            <p><b>Orgão Público:</b> {item.organ} {item.startDate ? <><b className='ms-3'>Data de Início:</b>{item.startDate}</> : '' } </p> 
                            <p className='mt-3'><b>Número: </b>{item.number}</p>
                            <p className='mt-3'><b>Assunto: </b>{item.subject}</p>
                            {item.file  && item.file.name ?
                                <Button variant="light" type="button" size="sm" onClick={() => handleClickFile(item.file.name, 'propriedade')}>
                                    <i className="bi bi-cloud-download-fill"></i>  {item.file.title || item.file.name}
                                </Button> : ''}
                            <p className='mt-3'>
                                {item.file && item.file.comments && item.file.comments !== '' ? <span><b>Observações:</b> {item.file.comments}</span> : ''}
                            </p>
                        </div>)
                        ) : ''}

                        {propertie.judicialProcess && propertie.judicialProcess.length > 0 ? <h6 className='mt-3'>Processo Judicial</h6> : ''}
                        {propertie.judicialProcess && propertie.judicialProcess.length > 0 ? propertie.judicialProcess.map((item, index) =>
                        (<div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                            <p><b>Tribunal:</b> {item.court}</p>
                            <p className='mt-3'><b>Número do Processo: </b>{item.number}</p>
                            <p className='mt-3'><b>Assunto: </b>{item.subject}</p>
                            {item.startDate ? <p className='mt-3'><b>Data de Início: </b>{item.startDate}</p> : ''}
                            {item.file  && item.file.name ?
                                <Button variant="light" type="button" size="sm" onClick={() => handleClickFile(item.file.name, 'propriedade')}>
                                    <i className="bi bi-cloud-download-fill"></i>  {item.file.title || item.file.name}
                                </Button> : ''}
                            <p className='mt-3'>
                                {item.file && item.file.comments && item.file.comments !== '' ? <span><b>Observações:</b> {item.file.comments}</span> : ''}
                            </p>
                        </div>)
                        ) : ''}

                        {propertie.car && propertie.car.length > 0 ? <h6 className='mt-3' style={{ width: '10%' }}>CAR</h6> : ''}
                        {propertie.car && propertie.car.length > 0 ? propertie.car.map((item, index) =>
                        (<div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                            <p className='mt-3'><b>Número: </b>{item.number}</p>
                        </div>)
                        ) : ''}

                        {propertie.dueDiligence && propertie.dueDiligence.length > 0 ? <h6 className='mt-3' style={{ width: '20%' }}>Due Diligence</h6> : ''}
                        {propertie.dueDiligence && propertie.dueDiligence.length > 0 ? propertie.dueDiligence.map((item, index) =>
                        (<div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                            <p><b>Data:</b> {item.date}</p>
                            {item.result && item.result !== '' ? <p><b className='mt-3'>Resultado:</b> {item.result}</p> : ''}
                            <p className='mt-3'>
                                {item.comments && item.comments !== '' ? <span><b>Observações:</b> {item.comments}</span> : ''}
                            </p>
                        </div>)
                        ) : ''}


                    </section>
                </Col>
            </Row>
        </Container>
    )
}

export default Details;